// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1JaxS","footer":"ChangeClinic_footer__3g2bO"};